export const validTabs = {
  eligibleModels: 'eligible-models',
  earnings: 'earnings',
}
